import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import staticURL from 'lib/staticURL';

export default function AssemblyLoadingAnimation(): JSX.Element {
  return (
    <div className={css(styles.iconWrapper)}>
      <img className={css(styles.plasmidSvg)} src={staticURL('static/img/assembly/plasmid.svg')} />
    </div>
  );
}

const keyframes = {
  '0%': {
    transform: 'rotate(360deg)',
  },
  '25%': {
    transform: 'rotate(270deg)',
  },
  '50%': {
    transform: 'rotate(180deg)',
  },
  '75%': {
    transform: 'rotate(90deg)',
  },
  '100%': {
    transform: 'rotate(0deg)',
  },
};

const styles = StyleSheet.create({
  iconWrapper: {
    position: 'relative',
    margin: 'auto',
    ':after': {
      content: '""',
      display: 'block',
      background: 'conic-gradient(from 360deg, #0000, #fff)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      width: '128px',
      height: '128px',
      zIndex: 2,
      animationName: [keyframes],
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'linear',
    },
  },
  plasmidSvg: {
    display: 'block',
    zIndex: 1,
  },
});
